// import React, { useContext } from 'react'
// import { SidebarContext } from '../context/SidebarContext'
// import MainApp from '../components/Sidebar/MainApp'
// import Collapsed from '../components/Sidebar/Collapsed'

// export default function Sidebar({ usrRole, isMobile }) {
//     const { isOpen } = useContext(SidebarContext)
//     return (
//         <div>
//             {isOpen ?
//                 <MainApp mobileSidebar={isMobile} />
//                 :
//                 <Collapsed />
//             }

//         </div>

//     )
// }

// ... existing code ...
import React, { useContext } from 'react';
import { SidebarContext } from '../context/SidebarContext'
import MainApp from '../components/Sidebar/MainApp'
import Collapsed from '../components/Sidebar/Collapsed'
// import SidebarLinks from './SidebarLinks';

export default function Sidebar({ usrRole, isMobile }) {
    const { isOpen, setIsOpen, isHoverOpen, setIsHoverOpen } = useContext(SidebarContext)

    const handleMouseEnter = () => {
        if (!isOpen) {
            setIsOpen(true);
            setIsHoverOpen(true); // Set to true when opened by hover
        }
    };

    const handleMouseLeave = () => {
        if (isHoverOpen) { // Only collapse if it was opened by hover
            setIsOpen(false);
            setIsHoverOpen(false); // Reset hover state
        }
    };

    return (
        <div
            className={`main-app-container ${isOpen ? 'expanded' : 'collapsed'}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {/* {isOpen ? (
                // Your existing expanded sidebar content
                <MainApp mobileSidebar={isMobile} />
            ) : (
                <Collapsed />
            )} */}
            <MainApp mobileSidebar={isMobile} />
        </div>
    );
}
// ... existing code ...